import { PersonDto, UserOrgUnitPermission, Version } from 'src/app/api/models';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { HubService } from 'src/app/shared/services/hub.service';
import { AppState } from 'src/app/store/states/app.state';
import { NavIconModel } from '../../shared/ui-elements/nav-icon/nav-icon.model';

import * as fromUserActions from 'src/app/store/actions/user.action';
import * as fromUserSelectors from 'src/app/store/selectors/user.selector';
import { ChangePasswordComponent } from 'src/app/shared/components/change-password/change-password.component';
import { PermissionCheckService } from 'src/app/shared/services/permission-check.service';
import { map, take } from 'rxjs/operators';
import { CustomTranslationService } from 'src/app/shared/translation/custom-translation.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { Languages } from 'src/app/shared/translation/languages.enum';
import * as fromStaticDataSelectors from '../../store/selectors/static-data.selector';

import { ToastrMsgService } from 'src/app/shared/services/toastr-msg.service';
import { untilComponentDestroyed } from 'src/app/shared/helpers/rxjs.operator';
import { VersionHelper } from 'src/app/shared/helpers/version.helper';
import { ModalDialogService } from 'src/app/shared/ui-elements/modal-dialog/modal-dialog.service';
import { MatSelectChange } from '@angular/material/select';
import { SwUpdate } from '@angular/service-worker';
import { UnsavedChangesHelper } from 'src/app/shared/helpers/unsaved-changes.helper';

@Component({
    selector: 'diana-header',
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit {
  activeIconIndex = 0;
  hasTenantPermission = false;
  hasOrgUnitPermission = false;
  isMenuOpen = false;
  selectedLanguage = Languages.de;
  version = '';
  currentNavigation = '/';

  public get isDianaSuisseAvailable(): boolean {
    return this.hubService.isDianaSuisseAvailable;
  }

  usersNavItem: NavIconModel = {
    idKey: 'users',
    iconName: 'manage_accounts',
    routerLink: '/users',
    textLabel: 'header.icon_label.users',
    isDisabled: false,
    isActive: false
  };

  calendarNavItem: NavIconModel = {
    idKey: 'calendar',
    iconName: 'event',
    routerLink: '/calendar',
    textLabel: 'header.icon_label.agenda',
    isDisabled: false,
    isActive: false
  }
  tenantNavItem: NavIconModel = {
    idKey: 'tenants',
    iconName: 'supervisor_account',
    routerLink: '/tenants',
    textLabel: 'header.icon_label.tenants',
    isDisabled: false,
    isActive: false
  }
  orgUnitNavItem: NavIconModel = {
    idKey: 'org-units',
    iconName: 'lan',
    routerLink: '/org-units',
    textLabel: 'header.icon_label.orgUnits',
    isDisabled: false,
    isActive: false
  }
  reportingNavItem: NavIconModel = {
    idKey: 'reporting',
    iconName: 'bar_chart',
    routerLink: '/reporting',
    textLabel: 'header.icon_label.reporting',
    isDisabled: false,
    isActive: false
  }
  customerNavItem: NavIconModel = {
    idKey: 'customer',
    iconName: 'contact_mail',
    routerLink: '/customer',
    textLabel: 'header.icon_label.customer',
    isDisabled: false,
    isActive: false,
    isOutlined: true
  }
  settingsNavItem: NavIconModel = {
    idKey: 'settings',
    iconName: 'tune',
    routerLink: '/settings',
    textLabel: 'header.icon_label.settings',
    isDisabled: false,
    isActive: false
  }
  newCustomerNavItem: NavIconModel = {
    idKey: 'add-customer',
    iconName: 'person_add',
    routerLink: '/add-customer',
    textLabel: 'header.icon_label.newCustomer',
    isDisabled: false,
    isActive: false
  }

  // TODO: Provide nav items through a service/backend (?)
  // TODO: Give unique and clear names to idKey properties
  navItems: NavIconModel[] = [
    /*{
      idKey: 'yearPLan',
      iconName: 'calendar_today',
      textLabel: 'header.icon_label.annual_planner',
      isDisabled: true
    },
    {
      idKey: 'invoices',
      iconName: 'receipt',
      textLabel: 'header.icon_label.invoices',
      isDisabled: true
    },

    {
      idKey: 'debitors',
      iconName: 'payments',
      textLabel: 'header.icon_label.debitors',
      isDisabled: true
    },
    {
      idKey: 'payments',
      iconName: 'money',
      textLabel: 'header.icon_label.payments',
      isDisabled: true
    },
    {
      idKey: 'fibu',
      iconName: 'fact_check',
      textLabel: 'header.icon_label.fibu',
      isDisabled: true
    },
    {
      idKey: 'addresses',
      iconName: 'contacts',
      textLabel: 'header.icon_label.customer',
      isDisabled: true
    },
    {
      idKey: 'pharmacy',
      iconName: 'local_hospital',
      textLabel: 'header.icon_label.pharmacy',
      isDisabled: true
    },
    {
      idKey: 'services',
      iconName: 'healing',
      textLabel: 'header.icon_label.services',
      isDisabled: true
    }*/
  ];

  isUserAuthenticated$?: Observable<boolean>;
  currentUser$?: Observable<PersonDto | null>;
  currentTenantName$?: Observable<string | undefined>;
  hasSwtichedTenant$?: Observable<boolean>;
  orgUnitPermissions$?: Observable<UserOrgUnitPermission[]>;
  currentOrgUnit?: string;
  hasMultipleOrgUnits$?: Observable<boolean>;

  constructor(
    private router: Router,
    private hubService: HubService,
    private store$: Store<AppState>,
    private dialogService: ModalDialogService,
    private permissionCheckService: PermissionCheckService,
    private translationService: CustomTranslationService,
    private localStorageService: LocalStorageService,
    private activatedRoute: ActivatedRoute,
    private toastrMsg: ToastrMsgService,
    private swUpdate: SwUpdate,
    private unsavedChangesHelper: UnsavedChangesHelper,
  ) {
    //using current route to show nav button with active color
    this.router.events.subscribe((data) => {
      if (data instanceof NavigationEnd) {
        this.currentNavigation = data.url;
        this.activateDesactivateNavIcons();
      }
    });
  }

  ngOnInit() {
    this.currentNavigation = this.router.url;
    this.activateDesactivateNavIcons();

    if (this.activatedRoute.firstChild?.url) {
      this.activatedRoute.firstChild?.url.subscribe(data => {
        if (data.length > 0) {
          this.currentNavigation = '/' + data[0].path;
          this.activateDesactivateNavIcons();
        }
      })
    }
    this.isUserAuthenticated$ = this.store$.select(
      fromUserSelectors.isUserAuthenticated
    );

    this.store$
      .pipe(
        select(fromStaticDataSelectors.getVersion()),
        untilComponentDestroyed(this)
      )
      .subscribe((version: Version) => {
        if (version && !version.commitHash) {
          version = this.localStorageService.getVersion();
        }
        this.version = VersionHelper.format(version);
      });

    this.currentUser$ = this.store$.select(fromUserSelectors.getCurrentUser);
    this.currentTenantName$ = this.store$.select(fromUserSelectors.currentTenantName);
    this.hasSwtichedTenant$ = this.store$.select(fromUserSelectors.hasSwtichedTenant);
    this.orgUnitPermissions$ = this.store$.select(fromUserSelectors.getOrgUnits);
    this.store$.select(fromUserSelectors.getCurrentOrgUnit).subscribe(orgUnitId => this.currentOrgUnit = orgUnitId);
    this.hasMultipleOrgUnits$ = this.orgUnitPermissions$.pipe(
      map(permissions => (permissions?.length || 0) > 1)
    );

    this.permissionCheckService.hasViewUsersPermission$().subscribe(hasViewUsersPermission => {
      this.permissionCheckService.hasViewRolesPermission$().pipe(take(1)).subscribe(hasViewRolesPermissions => {
        this.checkUpdateNavItems(hasViewRolesPermissions || hasViewUsersPermission, this.usersNavItem);
      });
    });
    this.permissionCheckService.hasViewCustomerPermission$().subscribe(hasPermission => {
      this.checkUpdateNavItems(hasPermission, this.customerNavItem);
    });
    this.permissionCheckService.hasViewTenantPermission$().subscribe(hasPermission => {
      this.hasTenantPermission = hasPermission;
      this.checkUpdateNavItems(hasPermission, this.tenantNavItem);

    });

    this.permissionCheckService.hasViewOrgUnitsPermission$().subscribe(hasPermission => {
      this.hasOrgUnitPermission = hasPermission;
      this.checkUpdateNavItems(hasPermission, this.orgUnitNavItem);
    });

    this.permissionCheckService.hasViewAppointmentsPermission$().subscribe(hasViewPermission => {
      this.permissionCheckService.hasManageNewCustomerPermission$().pipe(take(1)).subscribe(hasManageNewCustomerPermission => {
        this.checkUpdateNavItems(hasViewPermission, this.calendarNavItem, true, !hasViewPermission && !hasManageNewCustomerPermission);
      });
    });


    this.permissionCheckService.hasManageDianaPermission$().subscribe(hasManageDianaPermission => {
      this.permissionCheckService.hasManageMedicalHistoryPermission$().pipe(take(1)).subscribe(hasManageMedicalHistoryPermission => {
        this.checkUpdateNavItems(hasManageDianaPermission || hasManageMedicalHistoryPermission, this.reportingNavItem);
      });
    });

    this.permissionCheckService.hasViewSettingPermission$().subscribe(hasViewSettingPermission => {
      this.checkUpdateNavItems(hasViewSettingPermission, this.settingsNavItem);
    });

    this.permissionCheckService.hasManageNewCustomerPermission$().subscribe(hasManageNewCustomerPermission => {
      this.checkUpdateNavItems(hasManageNewCustomerPermission, this.newCustomerNavItem);
    });

    this.selectedLanguage = this.localStorageService.getLanguage() || this.translationService.mapLangToLanguage(this.translationService.defaultLang);
  }


  private checkUpdateNavItems(hasViewPermission: boolean, navItem: NavIconModel, isFirst: boolean = false, isDisabled: boolean = false) {
    const r = this.navItems.filter(n => n.idKey === navItem.idKey);
    if (r.length === 0) {
      navItem.isDisabled = isDisabled;
      if (hasViewPermission || (!hasViewPermission && isDisabled)) {
        if (isFirst) {
          this.navItems = [navItem, ...this.navItems];
        } else {
          this.navItems = [...this.navItems, navItem];
        }
      }
    } else if (r.length === 1) {
      r[0].isDisabled = isDisabled;
      if (!isDisabled && !hasViewPermission) {
        this.navItems = this.navItems.filter(n => n.idKey !== navItem.idKey);
      }
    }
  }

  public setFilterView(filterId: string) {
    // request to check if there is an updated version of the service worker
    if (this.swUpdate && this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate();
    }
    this.router.navigate([this.navItems.find(n => n.idKey === filterId)?.routerLink]);
  }

  private activateDesactivateNavIcons(): void {
    if (!this.currentNavigation) return;
    this.usersNavItem.isActive = this.currentNavigation.includes(this.usersNavItem.routerLink || '');
    this.calendarNavItem.isActive = this.currentNavigation.includes(this.calendarNavItem.routerLink || '');
    this.tenantNavItem.isActive = this.currentNavigation.includes(this.tenantNavItem.routerLink || '');
    this.orgUnitNavItem.isActive = this.currentNavigation.includes(this.orgUnitNavItem.routerLink || '');
    this.reportingNavItem.isActive = this.currentNavigation.includes(this.reportingNavItem.routerLink || '');
    this.customerNavItem.isActive = this.currentNavigation.includes(this.customerNavItem.routerLink || '');
    this.settingsNavItem.isActive = this.currentNavigation.includes(this.settingsNavItem.routerLink || '');
    this.newCustomerNavItem.isActive = this.currentNavigation.includes(this.newCustomerNavItem.routerLink || '');
  }

  openDianaSuisse() {
    this.hubService.executeAction('openDianaSuisse');
  }

  menuItemSelected(itemSelected: 'settings' | 'logout' | 'password' | 'de' | 'fr' | 'it') {

    switch (itemSelected) {
      case 'logout': {
        if (this.unsavedChangesHelper.isFormDirty) {
          this.unsavedChangesHelper.isFormDirtyConfirmationModal().subscribe(confirmation => {
            if (confirmation) {
              this.store$.dispatch(fromUserActions.logoutUser());
            }
          });
        } else {
          this.store$.dispatch(fromUserActions.logoutUser());
        }
        break;
      }

      case 'password':
        this.dialogService.openComponent(ChangePasswordComponent, this.currentUser$);
        break;
      case 'de':
      case 'fr':
      case 'it':
        const language = this.translationService.mapLangToLanguage(itemSelected);
        this.translationService.changeLoaderLoadLang(language);
        this.localStorageService.setLanguage(language);
        this.selectedLanguage = language;
        break;

      default:
        console.log(`Clicked: ${itemSelected}`);

        break;
    }
  }

  search() {
    console.log('Search action');
  }

  shoppingCart() {
    console.log('shopping Cart action');
  }

  notifications() {
    console.log('notifications action');
  }

  public copyVersion(): void {
    navigator.clipboard.writeText(this.version);
    this.toastrMsg.showInfo('login.copyVersion.toaster.info.message');
  }

  onOrgUnitChange($event: MatSelectChange) {
    this.store$.dispatch(fromUserActions.changeOrgUnit({ organizationalUnitId: $event.value }));
  }

}
